import { useState, useEffect } from 'react'
import { detectArea } from './areaDetectionConfig'

export function useJobsData(areaConfig) {
    const [jobs, setJobs] = useState([])
    const [mapping, setMapping] = useState({
        areaMapping: {},
        genreMapping: {},
        positionMapping: {}
    })
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(null)

    useEffect(() => {
        async function loadJobs() {
            try {
                setLoading(true)
                setError(null)
                
                const area = detectArea(areaConfig?.filters?.area)
                
                const response = await fetch(`/api/jobs?area=${area}`)
                
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`)
                }
                
                const data = await response.json()
                
                if (data.status === 'success' || data.status === 'cached') {
                    setJobs(data.jobs || [])
                    setMapping(data.mapping || {
                        areaMapping: {},
                        genreMapping: {},
                        positionMapping: {}
                    })
                } else {
                    throw new Error(data.message || 'Failed to load data')
                }
            } catch (err) {
                console.error('Failed to load jobs:', err)
                setError(err)

                setJobs([])
                setMapping({
                    areaMapping: {},
                    genreMapping: {},
                    positionMapping: {}
                })
            } finally {
                setLoading(false)
            }
        }

        loadJobs()
    }, [areaConfig])

    return { jobs, mapping, loading, error }
}
